/*       */

import { gql } from '@apollo/client';

export default gql`
    subscription onUserReferenceChange {
        result: onUserReferenceChange {
            id
            name
            image
            active
            username
        }
    }
`;
